export const fillSegments = (
	route: string,
	segmentsValues: Record<string, string | null>
): string => {
	let res = route;
	for (const [segmentKey, segmentVal] of Object.entries(segmentsValues).filter(
		([, v]) => v !== null && v !== undefined
	)) {
		res = res.replace(`:${segmentKey}`, segmentVal!.toString());
	}
	return res;
};
